import { HomeBaseView } from 'General/Views/Static/Home/HomeBaseView';

export class HomeView extends HomeBaseView {

}